import { HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, ContaBancaria, PagamentoResto, RetencaoResto, Usuario } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PagamentoRestoService extends BaseResourceService<PagamentoResto> {

  constructor(
    protected injector: Injector
  ) {
    super(`pagamentos-restos-pagar`, injector);
  }

  public acertarReceitaRetencoes(exercicio: number, orgao: number): Observable<number> {
    return this.http.get<number>(
      `${this.login.cidade.id}/${this.api}/acertar-receitas-retencoes/${exercicio}/${orgao}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public obterPorNumero(numero: number, ano: number, orgaoId: number): Observable<PagamentoResto> {
    return this.http.get<PagamentoResto>(
      `${this.login.cidade.id}/${this.api}?numero=${numero}&exercicio_ano=${ano}&orgao_id=${orgaoId}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public atualizarDataAnulacao(id: number, data: string, orgao_id: number): Observable<any> {
    return this.http.get<any>(`${this.login.cidade.id}/${this.api}/data-anulacao/${id}/${data}/${orgao_id}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err)))
  }

  public obterTotalPagoPorEmpenho(numero: number, ano: number, parcela: number, exercicioId: number, orgaoId: number): Observable<number> {
    return this.http.get<number>(
      `${this.login.cidade.id}/${this.api}/total-pago-por-empenho/${numero}/${ano}/${parcela}/${exercicioId}/${orgaoId}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public totalPagoRestoAno(exercicio: number, orgaoId: number): Observable<number> {
    return this.http.get<number>(`${this.login.cidade.id}/${this.api}/total-pago-ano/${exercicio}/${orgaoId}`, this.httpOptions()).pipe(
      map(res => res),
      catchError(err => this.handleError(err))
    );
  }

  public ultimaDataPagamento(exercicio: number, orgaoId: number): Observable<number> {
    return this.http.get<number>(
      `${this.login.cidade.id}/${this.api}/ultima-data-pagamento/${exercicio}/${orgaoId}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public anular(id: number, data: string, valor: number, historico: string, usuario: Usuario, conta: ContaBancaria, retencoes): Observable<PagamentoResto> {
    const anulacao = { id, data, valor, historico, usuario, conta, retencoes };
    return this.http.post<PagamentoResto>(
      `${this.login.cidade.id}/${this.api}/anular`, JSON.stringify(anulacao), {
      headers: new HttpHeaders(this.adicionarCriptografia({
        'Content-Type': 'application/json',
        Authorization: this.login.token
      }))
    });
  }

  public pagamentoEmLote(parametros: {
    numero_inicial: number, numero_final: number, ano: number, data_pagamento: string, documento: string,
    exercicio: number, orgao: number, conta: number, favorecido: number, ignorar?: { numero: number, parcela: number }[]
  }): Observable<{ numero: number, parcela: number, erro?: string }[]> {
    return this.http.post<{ numero: number, parcela: number, erro?: string }[]>(`${this.login.cidade.id}/${this.api}/pagamento-lote`,
      parametros, this.httpOptions());
  }

  public validarParcelas(numero_inicial: number, numero_final: number, ano: number, exercicio: number, orgao: number, favorecido?: number): Observable<{ numero: number, parcela: number, saldo_pagar: number }[]> {
    return this.http.get<{ numero: number, parcela: number, saldo_pagar: number }[]>(`${this.login.cidade.id}/${this.api}/duplicidade-pagamento-lote/${exercicio}/${orgao}/${numero_inicial}/${numero_final}/${ano}/${favorecido}`, this.httpOptions());
  }

  public obterTotalPagoPorLiquidacaoId(liquidacao: number): Observable<any> {
    return this.http.get(
      `${this.login.cidade.id}/${this.api}/total-pago-por-liquidacao/${liquidacao}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public atualizarSituacaoReinf(pagamento: PagamentoResto): Observable<any> {
    return this.http.post<{}[]>(`${this.login.cidade.id}/${this.api}/atualizar-situacao-reinf/${pagamento.id}/${pagamento.situacao}`, {}, this.httpOptions()).pipe(
      catchError(err => this.handleError(err))
    );
  }
}
